<div *ngIf="template" class="survey-reactive-content">
  <lib-survey-page-logo [title]="template.title" [subtitle]="template.subtitle">
    <img
      class="lib-survey-intro__image_title"
      *ngIf="template.image_title as image_title; else defaultImage"
      [src]="image_title"
    />

    <ng-template #defaultImage>
      <img src="/surveys-assets/images/first.svg" />
    </ng-template>
  </lib-survey-page-logo>

  <div
    class="lib-survey-intro__description survey__inner_html"
    [innerHtml]="template.description | safeHtml"
  ></div>

  <div *ngIf="user">
    <h3>{{ user.email }}</h3>
    <h3>{{ user.firstName }} {{ user.lastName }}</h3>
  </div>

  <div
    *ngIf="template.accept_policy_text"
    class="lib-survey-intro__accept_policy"
  >
    <mat-checkbox type="checkbox" [(ngModel)]="acceptPolicy">
      {{ template.accept_policy_text }}
    </mat-checkbox>
  </div>

  <div class="lib-survey-intro__buttons-row">
    <button
      mat-raised-button
      color="primary"
      data-test="next-page"
      class="btn action-button continuer-button"
      (click)="next.emit()"
      [disabled]="template.accept_policy_text && !acceptPolicy"
    >
      Commencer
    </button>
  </div>
</div>
